import { render, staticRenderFns } from "./UserBetHistory.vue?vue&type=template&id=ba93972a&lang=html"
import script from "./UserBetHistory.vue?vue&type=script&lang=js"
export * from "./UserBetHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports